<template>
    <div class="header" id="header" :class="{whiteHeader: isNotHomepage }">
        <nav v-if="!isMobile">
            <a class="logo_link" href="/">
                <img :src="logoSrc" alt="logo de GMA Logistics" loading='eager'>
            </a>
            <ul>
                <li v-for="item in menuItems" :key="item.id">
                    <a class="itemDesktop" :href="`#${item.id}`" @click.prevent="scrollToSection(item.id)">
                        {{ t(item.label) }}
                    </a>
                </li>
            </ul>
             <div class="language_switcher">
                <!-- <button class="flagBtn" v-if="locale === 'en'" @click="changeLanguage('fr')"><img :src ="currentFlag" /></button>
                <button class="flagBtn" v-else @click="changeLanguage('en')"><img :src="currentFlag"/></button> -->
                <button @click="toggleLanguage" class="flagBtn"><img :src="currentFlag" :alt="nextLanguage"/></button>
            </div>
        </nav>
        <div v-else class="burger">
            <a class="logo_link" href="/">
                <img src="../assets/logos/expert-logistique-stockage-livraison.webp" alt="logo de GMA Logistics" loading='eager'>
            </a>
            <Slide :width="menuWidth.toString()">
                <div class="mobile_logo_nav">
                    <img src="../assets/logos/gestion-service-livraison.webp" alt="logo de GMA Logistics" loading='lazy'>
                </div>
                <a class="itemMobile" v-for="item in menuItems" :key="item.id" :href="'#' + item.id">
                    {{ t(item.label) }}
                </a>
                  <div class="language_switcher">
                <!-- <button class="flagBtn" v-if="locale === 'en'" @click="changeLanguage('fr')"><img :src ="currentFlag" /></button>
                <button class="flagBtn" v-else @click="changeLanguage('en')"><img :src="currentFlag"/></button> -->
                <button @click="toggleLanguage" class="flagBtn"><img :src="currentFlag" :alt="nextLanguage" loading='eager'></button>
            </div>
            </Slide>
        </div>
    </div>
</template>

<script setup>
import { inject, ref, onMounted, onUnmounted, computed, onBeforeMount, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from 'vue-i18n';
/** @type {import('vue3-burger-menu).Slide} */
import { Slide } from 'vue3-burger-menu';

import logoWhite from '../assets/logos/gestion-stock-expertise.webp';
import logoBlack from '../assets/logos/expert-logistique-stockage-livraison.webp';
import frenchFlag from '../assets/graphic/distribution-livraison.webp';
import englishFlag from '../assets/graphic/delivery-logistics-expert.webp';

const router = useRouter();
const route = useRoute();
const isNotHomepage = computed(() => route.path !== '/');
const { t, locale } = useI18n();
const currentLanguage = computed(() => locale.value);
const nextLanguage = computed(() => currentLanguage.value === 'fr' ? 'en' : 'fr');
const currentFlag = computed(() => currentLanguage.value === 'fr' ? englishFlag : frenchFlag);
const isMobile = inject('isMobile');
const menuWidth = ref(window.innerWidth);
const scrollY = ref(window.scrollY);
const logoSrc = ref(logoWhite);
// let currentFlag = ref(englishFlag);
const menuItems = ref([
    { id: "logistique", label: "nav.qui"},
    { id: "solutions-logistique", label: "nav.solution"},
    { id: "experts-logistique", label: "nav.experts"},
    { id: "contact", label: "nav.contact"},
])
// const currentLogoSrc = computed(() => {
//     if(isNotHomepage.value || scrollY.value > 60) {
//         return logoBlack
//     } else {
//         return logoWhite
//     }
// }
//     // scrollY.value > 60 || isNotHomepage.value ? logoBlack : logoWhite
// )

const scrollToSection = async (id) => {
  if (window.location.pathname !== '/') {
    await router.push({ path: '/', hash: `#${id}` });
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        const yOffset = -120;
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 300); 
  } else {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -120;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
};


const handleScroll = () => {
  scrollY.value = window.scrollY;

  const header = document.querySelector('#header');
  const itemHeader = document.querySelectorAll(".itemDesktop");

  const shouldUseBlack = isNotHomepage.value || scrollY.value > 60;

  logoSrc.value = shouldUseBlack ? logoBlack : logoWhite;

  if (shouldUseBlack) {
    header?.classList.add('whiteHeader');
    itemHeader.forEach(item => item.classList.add('itemDesktopScroll'));
  } else {
    header?.classList.remove('whiteHeader');
    itemHeader.forEach(item => item.classList.remove('itemDesktopScroll'));
  }

//   console.log('Logo:', shouldUseBlack ? 'black' : 'white');
};



onBeforeMount(() => {
    window.removeEventListener('resize', updateMenuWidth);
})

onMounted(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', updateMenuWidth);
    handleScroll();
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});

const updateMenuWidth = () => {
    menuWidth.value = window.innerWidth;
}

const toggleLanguage = () => {
    locale.value = nextLanguage.value;
}

watch(() => route.path, () => {
  handleScroll() 
})


</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  z-index: 2;
  padding: 20px 25px;
  width: 100%;
  box-sizing: border-box;
  width: calc(100% - 40px);
  margin: 30px 20px 0 20px;
  border-radius: 30px;
  background-color: transparent;
  transition: background-color 0.3s ease;
  width: 85%;
  margin-left: 50%;
  transform: translateX(-50%);
}
.whiteHeader {
    background-color: #ffffff;
    transition: background-color 0.3s ease;
    box-shadow: 0 5px 20px 0px rgba(0, 0, 0, 0.15);
}
.logo_link {
  width: 340px;
  height: auto;
  flex-shrink: 0;
  margin-right: 20px;
}
.logo_link > img {
  width: 100%;
  height: 100%;
}
nav {
   display: flex;
   align-items: center;
   width: 100%;
}
ul {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-grow: 1;
    margin: 0;
    height: 100%;
    align-items: center;
    list-style-type: none;
    
}
ul li {
    margin-left: 30px;
}
.itemDesktop {
    color: #ffffff;
    text-decoration: none;
    font-weight: bold;
    font-size: 18px;
    transition: color 0.3s ease;
    font-family: 'Inter', sans-serif;
}
.itemDesktopScroll {
    color: #212121;
    transition: color 0.3s ease;
}
.itemDesktop:hover {
    color: #e91e63;
    transition: 0.3s;
}
.flagBtn {
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
    width: 30px;
    margin-left: 30px;
}
.flagBtn > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
@media screen and (min-width: 2000px ) {
    .header {
        max-width: 1800px;
    }
}
@media screen and (min-width: 751px ) and (max-width: 1200px){
    .logo_link {
        width: 290px;
    }
    ul li {
     margin-left: 15px;
    }
    .itemDesktop {
        font-size: 15px;
    }
}
@media screen and (max-width: 750px ) {
    .header {
        background: #ffffff;
        padding: 15px 15px;
        width: 100%;
        border-radius: 0;
        margin-top: 0;
    }
    .burger {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
        padding: 10px;
    }
    .logo_link {
        margin-right: 0;
        width: 270px;
        height: auto;
    }
    .mobile_logo_nav {
        width: 270px;
        height: auto;
        margin-bottom: 20px;
    }
    .mobile_logo_nav img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}


</style>
<style>
    /* .bm-burger-button {
        right: 36px !important;
        left: auto !important;
    }
    .bm-menu {
        left: auto !important;
        right: 0 !important;
        background-color: #ffffff;
        height: auto;
    }*/
  
    /* .bm-item-list {
        color: #212121;
        font-weight: 600;

    }  */
@media screen and (max-width: 750px ) {
    .burger {
        margin-left: auto ;
    }
    .bm-burger-button {
        top: 25px !important;
    }
    .bm-burger-bars {
        background-color: #e91e63 !important;
    }
    .line-style {
        height: 10% !important;
    }
    .bm-menu {
        height: 400px !important;
        /* width: 100vw !important; */
        background-color: #ffffff !important;
        padding-bottom: 20px;
    }
    .bm-item-list {
        color: #212121 !important;
        font-weight: 600 !important;
        margin-left: 0 !important;
        margin-top: 25px !important;
        position: absolute;
        top: 0;
    }
    .bm-item-list > * {
        padding: 18px !important;
    }
    .itemMobile {
        text-decoration: none !important;
        color: #212121 !important;

    }
    .bm-cross-button {
        top: 24px !important;
        right: 8px !important;
    }
    .bm-cross {
        height: 24px !important;
        background: #e91e63 !important;
    }
    .flagBtn {
        justify-content: center !important;
        margin-left: 0 !important;
    }
}
</style>